import { axios } from '@/utils/request'
import { mockRepaymentReport, useMock } from '@/webpublicapi/_mock'

//重新计算功能
export function dayFinancialCompute(parameter = {}) {
  return axios({
    url: '/order/dayFinancialCompute',
    method: 'post',
    data: parameter
  })
}

//数据导入接口
export function importCompanyDayReportExcel (parameter = {}) {
  return axios({
    url: '/order/importCompanyDayReportExcel',
    method: 'post',
    data: parameter
  })
}

//数据导出接口
export function exportCompanyDayReportExcel (parameter = {}) {
  return axios({
    url: `/order/exportCompanyDayReportExcel?paymentDateStart=${parameter.paymentDateStart}&paymentDateEnd=${parameter.paymentDateEnd}`,
    method: 'get',
    data: parameter,
    responseType:'blob'
  })
}


//数据查询接口
export function dayFinancialList (parameter = {}) {
  return axios({
    url: '/order/dayFinancialList',
    method: 'post',
    data: parameter
  })
}
